import { render, staticRenderFns } from "./logotitle.vue?vue&type=template&id=755b0ac9"
import script from "./logotitle.vue?vue&type=script&lang=js"
export * from "./logotitle.vue?vue&type=script&lang=js"
import style0 from "./logotitle.vue?vue&type=style&index=0&id=755b0ac9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports